import React from "react";
import { Play, Pause, Clock } from "lucide-react";

export const PodcastRow = ({ podcast, isPlaying, onToggle }) => (
  <div className="group flex items-center gap-5 py-5">
    <button
      onClick={() => onToggle(isPlaying ? null : podcast.id)}
      className={`flex items-center justify-center w-12 h-12 rounded-full shrink-0 transition-colors ${
        isPlaying ? "bg-[#0a6ed1]" : "bg-white/10 group-hover:bg-[#0a6ed1]"
      }`}
      aria-label={isPlaying ? "Pause" : "Play"}
    >
      {isPlaying ? (
        <Pause className="w-5 h-5 text-white" />
      ) : (
        <Play className="w-5 h-5 text-white ml-0.5" />
      )}
    </button>
    <div className="flex-1 min-w-0">
      <div className="flex items-center gap-3">
        <span className="text-xs font-700 uppercase tracking-wider text-[#5eb0f5]">
          {podcast.episode}
        </span>
        {isPlaying && (
          <span className="text-xs text-[#5eb0f5] animate-pulse">Now playing</span>
        )}
      </div>
      <h3 className="font-display font-700 text-lg text-white truncate">{podcast.title}</h3>
      <p className="text-sm text-slate-400">{podcast.guest}</p>
    </div>
    <div className="hidden sm:flex items-center gap-1.5 text-sm text-slate-400 shrink-0">
      <Clock className="w-4 h-4" /> {podcast.duration}
    </div>
  </div>
);
